// extracted by mini-css-extract-plugin
module.exports = {"edit":"JAAhtCWp","wrapper":"__6rJu34yp","form":"VxBbNtoQ","input":"__9H55L_y4","checkbox":"IIDZc_4K","operation":"Vj6DJJL3","cancel":"ZV1Ydlwo","ok":"SRNotgiZ"};